<div class="m-2">
    <!-- Note Entry Form -->
    <mat-card>
        <mat-card-content>
            <form [formGroup]="noteFormGroup">
                <div class="row align-items-start g-2">
                    <div class="col-12 col-md-6 col-lg">
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Note subject</mat-label>
                            <mat-select formControlName="subject" (selectionChange)="onchangeNoteSubject()">
                                <mat-option style="background-color: white;">
                                    <ngx-mat-select-search [formControl]="noteSubjectsFilter"
                                        placeholderLabel="Search note subjects"
                                        noEntriesFoundLabel="No matching note subjects found" />
                                </mat-option>
                                <mat-option *ngFor="let item of filteredNoteSubjects | async" [value]="item.subject">
                                    {{ item.subject }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-md-6 col-lg">
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Description</mat-label>
                            <input matInput formControlName="description" maxlength="250">
                            <mat-hint align="end">{{ noteFormGroup.get('description')?.value?.length || 0
                                }}/250</mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="col-6 col-md-4 col-lg-auto">
                        <button mat-raised-button color="primary" class="w-100 w-lg-auto"
                            style="min-width: 140px; height: 56px;"
                            (click)="openNoteModal(null, noteFormGroup.get('subject').value, noteFormGroup.get('description').value, null)"
                            [disabled]="isExternalUser(currentUser) || isSaveDisabled || isLoading">
                            <mat-icon>edit_note</mat-icon>
                            Add remark
                        </button>
                    </div>

                    <div class="col-6 col-md-4 col-lg-auto">
                        <button mat-raised-button color="primary" class="w-100 w-lg-auto"
                            style="min-width: 140px; height: 56px;" (click)="saveNote()"
                            [disabled]="isExternalUser(currentUser) || isSaveDisabled || isLoading">
                            <mat-icon>save</mat-icon>
                            Save
                        </button>
                    </div>
                </div>

                <div class="form-row" *ngIf="noteFormGroup.get('subject').value === 'Email Notes'">
                    <mat-form-field appearance="outline" class="email-field">
                        <mat-label>Select an email address</mat-label>
                        <mat-select formControlName="email_address" [(ngModel)]="selectedEmail">
                            <mat-option *ngFor="let item of officeEmails" [value]="item.email_addresses">
                                {{ item.email_addresses }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-row" *ngIf="callAttemptFlag">
                    <mat-form-field appearance="outline" class="call-attempt-field">
                        <mat-label>Call Attempt</mat-label>
                        <mat-select formControlName="RLI_Called_Count">
                            <mat-option *ngFor="let item of callAttempts.call_attempts" [value]="item.display_value">
                                {{ item.display_value }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <!-- Notes Table -->
    <mat-card class="mt-4">
        <mat-card-content>
            <div class="table-container">
                <table mat-table *ngIf="!isLoading" [dataSource]="notes" class="flat-table mat-elevation-z0">
                    <!-- Created Column -->
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Created</th>
                        <td mat-cell *matCellDef="let item">
                            <div class="date-time">
                                <div class="date">{{ item.created_time_formatted | date : 'yyyy-MM-dd' }}</div>
                                <div class="time">{{ item.created_time_formatted | date : 'hh:mm a' }}</div>
                                <div class="created-by">{{ item.created_by }}</div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Note Column -->
                    <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef>Note</th>
                        <td mat-cell *matCellDef="let item">
                            <div class="note-content">
                                <div *ngIf="item.pinned_at" class="pinned-label">
                                    <mat-icon>push_pin</mat-icon>
                                    Pinned by {{ item.pinned_by }}
                                </div>
                                <strong>{{ item.note_subject }}
                                    <span *ngIf="item.description" class="description">( {{ item.description }} )</span>
                                </strong>
                                <div class="note-text">{{ item.note }}</div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Modified Time Column (Admin only) -->
                    <ng-container matColumnDef="modified">
                        <th mat-header-cell *matHeaderCellDef>Modified</th>
                        <td mat-cell *matCellDef="let item">
                            <div class="date-time">
                                <div class="date">{{ item.modified_time_formatted | date : 'yyyy-MM-dd' }}</div>
                                <div class="time">{{ item.modified_time_formatted | date : 'hh:mm a' }}</div>
                                <div class="modified-by">{{ item.modified_by }}</div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Status Column (Admin only) -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let item">
                            <mat-chip *ngIf="item.note_status" [class.deleted]="item.note_status === 'Deleted'">
                                {{ item.note_status }}
                            </mat-chip>
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let item">
                            <div class="action-buttons">
                                <button mat-icon-button *ngIf="!isExternalUser(currentUser)" (click)="togglePin(item)"
                                    [class.pinned]="item.pinned_at" [matTooltip]="item.pinned_at ? 'Unpin' : 'Pin to top'">
                                    <mat-icon>push_pin</mat-icon>
                                </button>
                                <ng-container *ngIf="currentUser?.roleID === 0 || currentUser?.roleID === 1">
                                    <button mat-icon-button (click)="editNote(item)" matTooltip="Edit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="deleteNote(item.app_note_id)" matTooltip="Delete">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="currentUser?.roleID !== 0 && currentUser?.roleID !== 1">
                                    <button mat-icon-button (click)="changeNoteStatus(item.app_note_id)"
                                        [disabled]="isExternalUser(currentUser)" matTooltip="Delete">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </ng-container>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()" [class.pinned-row]="row.pinned_at"></tr>
                </table>
                <table mat-table *ngIf="isLoading" [dataSource]="getDummyNotesDataSource()"
                    class="flat-table mat-elevation-z0">
                    <!-- Created Column -->
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>Created</th>
                        <td mat-cell *matCellDef="let item">
                            <div class="date-time">
                                <div class="date">
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '20px', width: '80px', margin: '0' }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="time">
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '20px', width: '70px', margin: '0' }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="created-by">
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '20px', width: '140px', margin: '0' }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Note Column -->
                    <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef>Note</th>
                        <td mat-cell *matCellDef="let item">
                            <div class="note-content">
                                <strong>
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '20px', width: '900px', margin: '0' }">
                                    </ngx-skeleton-loader>
                                </strong>
                                <div class="note-text">
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '20px', width: '900px', margin: '0' }">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Modified Time Column (Admin only) -->
                    <ng-container matColumnDef="modified">
                        <th mat-header-cell *matHeaderCellDef>Modified</th>
                        <td mat-cell *matCellDef="let item">
                            &nbsp;
                        </td>
                    </ng-container>

                    <!-- Status Column (Admin only) -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let item">
                            &nbsp;
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let item">
                            <div class="action-buttons">
                                <ng-container>
                                    <button mat-icon-button [disabled]="true" matTooltip="Edit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button [disabled]="true" matTooltip="Delete">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </ng-container>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
                </table>
            </div>

            <div *ngIf="isLoadingMore" class="load-more">
                <mat-spinner diameter="24"></mat-spinner>
            </div>
            <div *ngIf="!isLoading && !notes.length" class="no-notes">No notes</div>
            <div #loadMoreSentinel></div>
        </mat-card-content>
    </mat-card>
</div>